import React, { useEffect, useMemo, useState } from "react";
import { Button, Card, Col, Container, Row } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import api from "../api/axios";

const LandingNegocios = () => {
  const navigate = useNavigate();
  const [mapItems, setMapItems] = useState([]);
  const [loadingMapItems, setLoadingMapItems] = useState(true);
  const [mapModuleEnabled, setMapModuleEnabled] = useState(true);

  useEffect(() => {
    const loadFeatureFlags = async () => {
      try {
        const res = await api.get("/feature-flags/public");
        const enabled = Boolean(res.data?.flags?.map_module_enabled);
        setMapModuleEnabled(enabled);
      } catch (err) {
        setMapModuleEnabled(true);
      }
    };

    loadFeatureFlags();
  }, []);

  useEffect(() => {
    if (!mapModuleEnabled) {
      setMapItems([]);
      setLoadingMapItems(false);
      return;
    }

    const fetchMapItems = async () => {
      try {
        const { data } = await api.get("/business/public-locations");
        const items = Array.isArray(data?.items) ? data.items : [];
        setMapItems(items.slice(0, 20));
      } catch (err) {
        console.error("Error cargando mapa en landing:", err);
        setMapItems([]);
      } finally {
        setLoadingMapItems(false);
      }
    };

    fetchMapItems();
  }, [mapModuleEnabled]);

  const featuredBusiness = useMemo(() => mapItems[0] || null, [mapItems]);
  const mapLat = Number(featuredBusiness?.latitude);
  const mapLng = Number(featuredBusiness?.longitude);
  const hasMap = Number.isFinite(mapLat) && Number.isFinite(mapLng);
  const mapDelta = 0.008;
  const mapSrc = hasMap
    ? `https://www.openstreetmap.org/export/embed.html?bbox=${mapLng - mapDelta}%2C${mapLat - mapDelta}%2C${mapLng + mapDelta}%2C${mapLat + mapDelta}&layer=mapnik&marker=${mapLat}%2C${mapLng}`
    : "";

  return (
    <Container className="py-5">
      <Row className="justify-content-center text-center mb-4">
        <Col lg={9}>
          <h1 className="fw-bold mb-3">Mas clientes, mas visitas, mas consumo</h1>
          <p className="text-secondary mb-4">
            QR Benefits te permite publicar beneficios, generar reclamos con QR y medir consumos
            reales desde un panel simple.
          </p>
          <div className="d-flex flex-wrap justify-content-center gap-2">
            <Button variant="primary" onClick={() => navigate("/register")}>
              Empezar gratis 30 dias
            </Button>
            <Button variant="outline-primary" onClick={() => navigate("/contacto-comercios")}>
              Hablar con ventas
            </Button>
          </div>
        </Col>
      </Row>

      <Row className="g-3 mb-4">
        <Col md={4}>
          <Card className="h-100 shadow-sm">
            <Card.Body>
              <h5>1. Publica beneficios</h5>
              <p className="text-muted mb-0">
                Crea promociones en minutos y actualizalas cuando quieras.
              </p>
            </Card.Body>
          </Card>
        </Col>
        <Col md={4}>
          <Card className="h-100 shadow-sm">
            <Card.Body>
              <h5>2. Reclamos con QR</h5>
              <p className="text-muted mb-0">
                Tus clientes reclaman con un codigo y vos validas el consumo.
              </p>
            </Card.Body>
          </Card>
        </Col>
        <Col md={4}>
          <Card className="h-100 shadow-sm">
            <Card.Body>
              <h5>3. Mide resultados</h5>
              <p className="text-muted mb-0">
                Segui reclamos, consumos y reseñas desde el backoffice.
              </p>
            </Card.Body>
          </Card>
        </Col>
      </Row>

      {mapModuleEnabled && (
      <Row className="mb-4">
        <Col>
          <Card className="shadow-sm">
            <Card.Body>
              <div className="d-flex justify-content-between align-items-center flex-wrap gap-2 mb-3">
                <h5 className="mb-0">Comercios adheridos en el mapa</h5>
                <span className="text-muted small">{mapItems.length} visibles</span>
              </div>
              {loadingMapItems ? (
                <div style={{ height: 260, borderRadius: 8, background: "#eef2f7" }} />
              ) : hasMap ? (
                <>
                  <div
                    style={{
                      border: "1px solid #dee2e6",
                      borderRadius: 8,
                      overflow: "hidden",
                      marginBottom: 10,
                    }}
                  >
                    <iframe
                      title="Mapa de comercios adheridos"
                      src={mapSrc}
                      style={{ width: "100%", height: 280, border: 0 }}
                      loading="lazy"
                    />
                  </div>
                  <div className="d-flex flex-wrap gap-2">
                    {mapItems.slice(0, 8).map((item) => (
                      <span key={`landing-map-${item.id}`} className="badge text-bg-light border">
                        {item.name}
                      </span>
                    ))}
                  </div>
                </>
              ) : (
                <p className="text-muted mb-0">
                  Todavia no hay comercios con ubicacion cargada.
                </p>
              )}
            </Card.Body>
          </Card>
        </Col>
      </Row>
      )}

      <Row className="justify-content-center">
        <Col lg={6}>
          <Card className="shadow-sm border-primary">
            <Card.Body className="text-center">
              <h4 className="fw-bold mb-1">Plan unico</h4>
              <div className="text-muted mb-3">Ideal para validar rapido en tu local</div>
              <div className="display-6 fw-bold">USD 10/mes</div>
              <div className="text-success fw-semibold mb-3">30 dias gratis al registrarte</div>
              <div className="small text-muted mb-3">
                Sin permanencia. Cancelas cuando quieras.
              </div>
              <Button variant="primary" onClick={() => navigate("/register")}>
                Crear cuenta de negocio
              </Button>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default LandingNegocios;
